var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21515",
    "data-name": "Group 21515",
    transform: "translate(-0.235 -0.468)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_143",
    "data-name": "Ellipse 143",
    cx: 22.5,
    cy: 22,
    rx: 22.5,
    ry: 22,
    transform: "translate(0.235 0.468)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(13.955 11.932)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "apple-_173_",
    "data-name": "apple-[#173]",
    d: "M57.588,7282.194A4.275,4.275,0,0,0,58.675,7279a4.731,4.731,0,0,0-3.079,1.521,4.06,4.06,0,0,0-1.11,3.095,3.923,3.923,0,0,0,3.1-1.423m2.632,7.451a4.454,4.454,0,0,0,2.805,4.047,10.749,10.749,0,0,1-1.446,2.854c-.872,1.212-1.776,2.434-3.2,2.453-1.4.029-1.85-.791-3.451-.791s-2.1.771-3.425.82c-1.375.051-2.423-1.32-3.3-2.533-1.8-2.493-3.169-7.029-1.326-10.094a5.169,5.169,0,0,1,4.327-2.514c1.35-.02,2.625.871,3.45.871s2.375-1.071,4-.911a4.928,4.928,0,0,1,3.824,1.981,4.521,4.521,0,0,0-2.259,3.816",
    transform: "translate(-46 -7279.001)",
    fill: "#fff",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple-icon.941c2ec115ef356c98557343696dcd0a.svg";
export { ForwardRef as ReactComponent };